import {
  Button,
  Drawer,
  Form,
  FormItem,
  Input,
  Select,
  Option,
} from "element-ui";
import { find } from "lodash";
import isMobile from "@/shared/utils/isMobile";

const initFormVal = {
  brokerName: 1,
  serverId: "",
  account: "",
  cwPassword: "",
};

const FollowSignalDrawer = {
  data() {
    const checkMt4 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("Common_Valid_CheckMt4Account")));
      } else if (
        !Number.isInteger(Number(value)) ||
        value.length < 5 ||
        value.length > 10
      ) {
        callback(new Error(this.$t("Common_Valid_CheckMt4AccountNum")));
      } else {
        callback();
      }
    };
    return {
      followSignalDrawerVisible: false,
      brokerList: [],
      followSignalFormVal: initFormVal,
      loading: false,
      followSignalFormRule: {
        brokerName: [
          {
            required: true,
            message: this.$t("Common_Valid_BrokerNotNull"),
            trigger: "change",
          },
        ],
        serverId: [
          {
            required: true,
            message: this.$t("Common_valid_ServerNotNull"),
            trigger: "change",
          },
        ],
        account: [{ validator: checkMt4, trigger: "change" }],
        cwPassword: [
          {
            required: true,
            message: this.$t("Common_Valid_Mt4PasswordNotNull"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    serverLists() {
      if (this.followSignalFormVal.brokerName) {
        const nextBroker = find(this.brokerList, {
          id: this.followSignalFormVal.brokerName,
        });
        return nextBroker?.serverList ?? [];
      }
      return [];
    },
  },
  props: ["linkId"],
  mounted() {},
  created() {
    this.getServeList();
  },
  methods: {
    getServeList() {
      this.$axios.get("/Api/invite/BrokerList").then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.brokerList = dt.result;
        }
      });
    },
    toReg() {
      window.open(`https://crm.ecmarkets.co/${this.lang}/sign/register`);
    },
    open() {
      this.followSignalDrawerVisible = true;
    },
    close() {
      this.$refs.followSignalForm.resetFields(initFormVal);
      this.followSignalDrawerVisible = false;
    },
    handleSubmit() {

     this.$confirm(
        this.$t("ViewInvitation_NoChangePasswordContent"),
        this.$t("Common_Prompt"),
        {
          confirmButtonText: this.$t("Common_Confirm"),
          cancelButtonText: this.$t("Common_Cancel"),
          type: "warning",
        }
      ).then(() => {
          this.$refs.followSignalForm.validate((valid) => {
          if (valid) {
            this.loading = true;

            const params = {
              linkId: this.linkId,
              account: this.followSignalFormVal.account,
              serverId: this.followSignalFormVal.serverId,
              cwPassword: this.followSignalFormVal.cwPassword,
            };

            this.$axios
              .post("/api/Portfolio/FollowByLink", params)
              .then((res) => {
                let dt = res.data;
                if (dt.isSuccess) {
                  this.$notify.success({
                    title: this.$t("Common_Prompt"),
                    message: this.$t("Common_OperateSuccess"),
                  });
                  // 成功后跳转到：跟随-跟随列表
                  this.$router.push({ path: "/MyFollow" });
                } else {
                  this.$notify.error({
                    title: this.$t("Common_Prompt"),
                    message: dt.result,
                  });
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      })
    .catch(error => {});
    },
  },

  render() {
    return (
      <Drawer
        title={this.$t("Follow_Signal")}
        class="drawerCommon"
        direction="rtl"
        appendToBody
        closeOnPressEscape={false}
        visible={this.followSignalDrawerVisible}
        onClose={this.close}
      >
        <div class="drawerContent">
          <Form
            ref="followSignalForm"
            labelPosition={isMobile ? "top" : "right"}
            labelWidth="150px"
            class="drawerForm"
            props={{ model: this.followSignalFormVal }}
            rules={this.followSignalFormRule}
          >
            {/* 交易商 */}
            <FormItem
              label={this.$t("Common_Mt4BrokerName")}
              prop="brokerName"
              class="toReg"
            >
              <Select v-model={this.followSignalFormVal.brokerName}>
                {this.brokerList.map((item) => (
                  <Option
                    key={item.id}
                    label={item.brokerName}
                    value={item.id}
                  />
                ))}
              </Select>
              <p>
                <span onClick={this.toReg}>
                  {this.$t("ViewInvitation_NoAccountRegister")}
                </span>
              </p>
            </FormItem>
            {/* 服务器 */}
            <FormItem label={this.$t("Common_Mt4Server")} prop="serverId">
              <Select
                v-model={this.followSignalFormVal.serverId}
                class="allLengthInput"
              >
                {this.serverLists.map((item) => (
                  <Option
                    key={item.serverId}
                    label={item.serverName}
                    value={item.serverId}
                  />
                ))}
              </Select>
            </FormItem>
            {/* MT4账号 */}
            <FormItem label={this.$t("Common_Mt4Account")} prop="account">
              <Input
                v-model={this.followSignalFormVal.account}
                autocomplete="off"
              />
            </FormItem>
            {/* 交易密码 */}
            <FormItem
              label={this.$t("Common_Mt4AccountPassword")}
              prop="cwPassword"
            >
              <Input
                type="password"
                v-model={this.followSignalFormVal.cwPassword}
                autocomplete="off"
                showPassword
              />
            </FormItem>
          </Form>
          <div class="drawerBtns">
            {/* 确认 */}
            <Button
              class="confirmDialogBtn"
              v-loading={this.loading}
              onClick={this.handleSubmit}
            >
              {this.$t("Common_Confirm")}
            </Button>
            {/* 返回 */}
            <Button class="cancelDialogBtn" onClick={this.close}>
              {this.$t("Common_Back")}
            </Button>
          </div>
        </div>
      </Drawer>
    );
  },
};

export default FollowSignalDrawer;
